import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useOperationFormById from 'screens/Applications&WorkOrders/Components/hooks/useOperationFormById';
import StepsLayout from 'screens/Applications&WorkOrders/StepsLayout';
import { useAuth } from 'utilities/base-auth';
import { RoutePathState } from 'screens/Applications&WorkOrders/RouteAdmin';
import convertWorkOrderToApplicationFormikData from './Helpers/convertWorkOrderToApplicationFormikData';

export const CreateApplicationFromWorkOrder: React.FC = () => {
  const location = useLocation<RoutePathState>();
  const workOrderId = location.state.operation?.id ?? '';
  const { setValues } = useFormikContext<any>();
  const { loading, operationFormikData } = useOperationFormById(
    workOrderId,
    'work-order'
  );

  const { user } = useAuth();

  useEffect(() => {
    if (!loading && operationFormikData) {
      setValues((prevValues: any) =>
        convertWorkOrderToApplicationFormikData(
          operationFormikData,
          prevValues,
          user
        )
      );
    }
  }, [loading, operationFormikData, setValues, user]);

  return <StepsLayout isLoading={loading} />;
};

export default CreateApplicationFromWorkOrder;
